import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const fetchCreateTeTicketThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.supportTicketCreate, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchticketCategoriesThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.ticketCategoriesListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchticketListingThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getticketListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchaddMessageThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.addMessage, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchgetTicketMessagesThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getTicketMessages(body))
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
